<template>
  <div class="wrap-box">
    <div class="wrap-box-left">
      <Form ref="searchForm" :model="searchForm">
        <div v-if="isAdvanceSearch">
          <Row>
            <Col :xs="24" :sm="24" :lg="8">
              <FormItem
                :label="$t('label.project.country')"
                :label-width="90"
                style="margin-bottom: 10px;"
              >
                <Select
                  transfer
                  filterable
                  v-model="searchForm.country"
                  class=""
                  transfer-class-name="pbr"
                  multiple
                  :max-tag-count="0"
                  clearable
                  :placeholder="$t('label.country')"
                >
                  <Icon
                    v-if="searchForm.country && searchForm.country.length > 0"
                    type="md-close-circle"
                    slot="prefix"
                    style="display: flex;"
                    @click.stop="searchForm.country = []"
                  />
                  <template v-for="par in countryList">
                    <OptionGroup
                      :label="par.title ? par.title : '洲'"
                      :key="par.title"
                    >
                      <Option
                        v-for="child in par.children"
                        :value="JSON.stringify(child)"
                        :key="child.id"
                      >
                        {{ child.title }}
                      </Option>
                    </OptionGroup>
                  </template>
                  <!--                      <Option v-for="item in countryList" :value="JSON.stringify(item)" :key="item.id">{{-->
                  <!--                          item.name-->
                  <!--                        }}-->
                  <!--                      </Option>-->
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :lg="8">
              <FormItem
                :label="$t('label.industry')"
                :label-width="90"
                style="margin-bottom: 10px;"
              >
                <Select
                  transfer
                  filterable
                  v-model="searchForm.industry"
                  class=""
                  transfer-class-name="pbr"
                  multiple
                  :max-tag-count="0"
                  :max-tag-placeholder="maxTagPlaceholder"
                  clearable
                  :placeholder="$t('label.project.industry')"
                >
                  <Icon
                    v-if="searchForm.industry && searchForm.industry.length > 0"
                    type="md-close-circle"
                    slot="prefix"
                    style="display: flex;"
                    @click.stop="searchForm.industry = []"
                  />
                  <Option
                    v-for="item in industryList"
                    :value="JSON.stringify(item)"
                    :key="item.id"
                    >{{ item.title }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col :xs="24" :sm="24" :lg="8">
              <FormItem
                :label="$t('table.project.main.biddingProjectType')"
                :label-width="90"
                style="margin-bottom: 10px;"
              >
               <Input v-model="searchForm.biddingProjectType" :placeholder="$t('table.project.main.biddingProjectType')" />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col :xs="24" :sm="24" :lg="8">
              <FormItem
                :label="$t('table.project.main.state')"
                :label-width="90"
                style="margin-bottom: 10px;"
              >
                <Select
                  transfer
                  filterable
                  v-model="searchForm.projectStatus"
                  transfer-class-name="pbr"
                  clearable
                  :placeholder="$t('table.project.main.state')"
                >
                  <Option
                    v-for="item in projectStatusList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.title }}
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
        </div>
        <div style="margin-bottom: 10px;">
          <AutoComplete
            clearable
            v-model="searchForm.keywords"
            transfer
            @on-focus="
              () => {
                this.associationWordsList = [];
              }
            "
            @on-search="associationWords"
            :placeholder="$t('placeholders.project.search')"
            class="auto-complete"
            style=""
          >
            <Option
              v-for="item in associationWordsList"
              :value="item"
              :key="item"
              >{{ item }}</Option
            >
          </AutoComplete>

          <Button @click="search(false)" type="primary" style="">{{
            $t("buttons.search")
          }}</Button>
          <Button @click="reset(false)" style="">{{
            $t("buttons.reset")
          }}</Button>
          <el-link
            type="text"
            :underline="false"
            @click="openHistory"
            style="color: #008bce;cursor: pointer;"
            class="padding5"
            v-html="$t('buttons.searchHistory')"
          ></el-link>
          <el-link
            v-if="isAdvanceSearch"
            class="padding5"
            type="default"
            :underline="false"
            @click="advanceSearchBtnClick(false)"
            v-html="$t('buttons.advanceRetrieval', { type: 'up' })"
          ></el-link>
          <el-link
            v-else
            class="padding5"
            type="default"
            :underline="false"
            @click="advanceSearchBtnClick(true)"
            v-html="$t('buttons.advanceRetrieval', { type: 'down' })"
          ></el-link>
        </div>
        <div
          v-if="isAdvanceSearch"
          v-show="Object.keys(myCondition).length > 0"
          class="my-condition-box"
          style=""
        >
          <label style="float:left;line-height: 27px;"
            >{{ $t("label.project.searchCondition") }}：</label
          >
          <div style="margin-left: 110px;">
            <p v-for="(item, key) in myCondition">
              <label>{{ item.tag }}：</label>
              <template v-if="key === 'pdate'">
                <span class="condition-text">
                  {{ item.list.join(" - ") }}
                </span>
              </template>
              <template v-else-if="key === 'weight'">
                {{
                  item.list === "1"
                    ? $t("table.project.main.yes")
                    : $t("table.project.main.orNo")
                }}
              </template>
              <template v-else-if="item.text !== undefined">
                <span class="condition-text">{{ item.text }}</span>
              </template>
              <template v-else>
                <span v-for="(obj, i) in item.list">
                  <span class="condition-text">
                    <i
                      @click="item.list.splice(i, 1)"
                      class="condition-item-close el-icon-error"
                    ></i
                    >{{ JSON.parse(obj).title || JSON.parse(obj).name }}
                  </span>
                  {{ i === item.list.length - 1 ? "" : "，" }}
                </span>
              </template>
              <i
                @click="clearSearchCondition(key)"
                class="el-icon-circle-close condition-close"
              ></i>
            </p>
          </div>
        </div>
      </Form>
      <div class="table-top-box">
        <span class="fr right" @click="openPublishModal"
          ><i
            class="el-icon-s-promotion"
            style="color: #008bce;font-size: 16px;"
          ></i
          >{{ $t("buttons.project.publishProject") }}</span
        >
        <span class="fr right  div-xs-hidden" @click="exportPDF"
          ><span class="excel-png"></span>{{ $t("buttons.export") }}</span
        >
      </div>
      <Table
        class="pbr"
        border
        :columns="columns"
        :data="tableData"
        :loading="tableLoading"
        @on-selection-change="tableSelectionChange"
        @on-sort-change="projectListTableSortChange"
        style="margin-top: 10px;"
      >
        <template slot-scope="{ row }" slot="favorites">
          <Icon
            color="#008acd"
            @click="editFavorite(row)"
            :type="row.focue ? 'md-star' : 'md-star-outline'"
            style="font-size: 20px;cursor: pointer"
          />
        </template>
        <template slot-scope="{ row }" slot="title">
          <span
            class="project-title"
            style="cursor:pointer"
            @click.stop="jumpProjectDetail(row)"
            v-html="row.title"
          ></span>
        </template>
        <template slot-scope="{ row }" slot="projectStatus">
          {{ formatProjectStatus(row.projectStatus) }}
        </template>
        <template slot-scope="{ row }" slot="projectBidPublishDate">
          {{ row.projectBidPublishDate }}
        </template>
        <template slot-scope="{ row }" slot="projectDeadline">
          {{ row.projectDeadline }}
        </template>
      </Table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
        style="margin-top: 10px"
      >
      </el-pagination>
    </div>
    <div class="wrap-box-right">
      <div class="project-data">
        <div class="pbr-title">{{ $t("label.project.projectData") }}</div>
        <div class="project-data-content">
          <el-row :gutter="10">
            <el-col :span="12">
              <div class="project-data-item">
                <img
                  src="../common/img/project_num.png"
                  class="project-data-item-img"
                  alt=""
                />
                <strong
                  :title="
                    projectData.projectcount + $t('label.project.individual')
                  "
                  >{{ projectData.projectcount }}</strong
                ><strong v-if="!isEN" :class="{ newline: isEN }">{{
                  $t("label.project.individual")
                }}</strong>
                <p :class="{ newline: isEN }">
                  {{ $t("label.project.projectNumber") }}
                </p>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="project-data-item">
                <img
                  src="../common/img/related_country.png"
                  class="project-data-item-img"
                  alt=""
                />
                <strong
                  :title="
                    projectData.countrycount + $t('label.project.individual')
                  "
                  >{{ projectData.countrycount }}</strong
                ><strong v-if="!isEN" :class="{ newline: isEN }">{{
                  $t("label.project.individual")
                }}</strong>
                <p :class="{ newline: isEN }">
                  {{ $t("label.project.countriesInvolved") }}
                </p>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="12">
              <div class="project-data-item">
                <img
                  src="../common/img/project_amount.png"
                  class="project-data-item-img"
                  alt=""
                  style="margin-top: -6px;"
                />
                <Poptip
                  trigger="hover"
                  popper-class="pbr-project-amount-poptip"
                  :content="projectData.totalamount"
                >
                  <strong>{{ projectData.totalamount }}</strong>
                </Poptip>

                <p :class="{ newline: isEN }">
                  {{ $t("label.project.projectAmount") }}
                </p>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="project-data-item">
                <img
                  src="../common/img/relate_industry.png"
                  class="project-data-item-img"
                  alt=""
                />
                <strong
                  :title="
                    projectData.industrycount + $t('label.project.individual')
                  "
                  >{{ projectData.industrycount }}</strong
                ><strong v-if="!isEN" :class="{ newline: isEN }">{{
                  $t("label.project.individual")
                }}</strong>
                <p :class="{ newline: isEN }">
                  {{ $t("label.project.industriesInvolved") }}
                </p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="project-chart-box">
        <div class="pbr-title">{{ $t("label.project.projectHotWords") }}</div>
        <div class="project-chart">
          <HotWordAnalysis
            v-if="hotWordData.length"
            :word-data="hotWordData"
            @hotClick="hotClick"
          ></HotWordAnalysis>
          <Empty v-else></Empty>
        </div>
      </div>
    </div>
    <PublishProject ref="publish"></PublishProject>
    <el-dialog
      :visible.sync="historyModal"
      :modal="false"
      :title="$t('table.project.history.title')"
      append-to-body
      custom-class="pbr"
      width="600px"
    >
      <div style="text-align: right;margin-bottom: 10px;">
        <Button @click="delAllHistory" type="primary">{{
          $t("buttons.delAll")
        }}</Button>
      </div>
      <Table
        border
        :columns="historyColumns"
        :data="historyTableData"
        @on-row-click="dblclickHistory"
        class="pbr-info-history-table"
      >
        <template slot-scope="{ row }" slot="top">
          <div @click.stop="toTopHistory(row)" style="cursor:pointer;">
            <Icon
              :class="favIconClass(row)"
              type="md-arrow-round-up"
              style="font-size: 20px;"
            />
          </div>
        </template>
        <template slot-scope="{ row }" slot="operate">
          <Icon
            @click.stop="delHistory(row)"
            v-if="!row.del"
            type="md-trash"
            style="font-size: 20px;cursor:pointer;"
          />
        </template>
      </Table>
    </el-dialog>
    <div v-show="false" ref="submitForm">
      <form
        method="get"
        target="_blank"
        enctype="multipart/form-data"
        :action="action"
      >
        <input name="selections" type="text" />
        <input name="from" type="text" value="cn" />
      </form>
    </div>
  </div>
</template>

<script>
import PublishProject from "./PublishProject";
import HotWordAnalysis from "../analysis/HotWordAnalysis";
import { contentType, exportFile, exportFilePost } from "../apis/common";

export default {
  name: "pbrProjectIndex",
  components: {
    PublishProject,
    HotWordAnalysis,
  },
  data() {
    var self = this;
    return {
      action: this.$pbrApis.exportProjectListExcelUrl,
      questionVisible: false,
      isSmall: false,
      searchForm: {
        country: [],
        industry: [],
        company: [],
        category: [],
        stage: [],
        amount: [],
        pdate: [],
        date: [],
        keywords: "",
        orderby: "",
        orderkey: "",
        name: "",
        weight: "",
        biddingProjectType: "",
        projectStatus: null
      },
      companyQuery: "",
      isCompanyOpen: false,
      associationWordsList: [],
      countryList: [],
      industryList: [],
      categoryList: [],
      companyList: [],
      stageList: [],
      amountList: [],
      keyProjectList: [
        { id: "1", title: this.$t("table.project.main.yes") },
        { id: "2", title: this.$t("table.project.main.orNo") }
      ],
      dateList: [],
      dateOptions: {
        shortcuts: [
          {
            text: this.$t("datePicker.threeMonths"),
            value() {
              const end = self.$moment().format("yyyy-MM-DD");
              const start = self
                .$moment()
                .subtract(3, "month")
                .format("yyyy-MM-DD");
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              return [start, end];
            }
          },
          {
            text: this.$t("datePicker.oneYear"),
            value() {
              const end = self.$moment().format("yyyy-MM-DD");
              const start = self
                .$moment()
                .subtract(1, "year")
                .format("yyyy-MM-DD");

              return [start, end];
            }
          },
          {
            text: this.$t("datePicker.threeYears"),
            value() {
              const end = self.$moment().format("yyyy-MM-DD");
              const start = self
                .$moment()
                .subtract(3, "year")
                .format("yyyy-MM-DD");

              return [start, end];
            }
          }
        ]
      },
      showMoreCondition: false,
      /**/
      myCondition: {},
      /**/
      tableLoading: false,
      columns: [],
      tableData: [],
      tableSelection: [],
      currentPage: 1,
      pageSize: 10,
      tableTotal: 0,
      /**/
      projectData: {
        projectcount: 0,
        countrycount: 0,
        totalamount: 0,
        industrycount: 0
      },
      hotWordData: [],
      /**/
      historyModal: false,
      historyColumns: [
        {
          title: this.$t("table.project.history.columns.top"),
          width: 50,
          slot: "top",
          align: "center"
        },
        {
          title: this.$t("table.project.history.columns.title"),
          key: "name"
        },
        {
          title: this.$t("table.project.history.columns.delete"),
          width: 80,
          slot: "operate",
          align: "center"
        }
      ],
      historyTableData: [],
      isAdvanceSearch: false,
      locale: localStorage.getItem("locale"),
      isSearchByName: false,
      projectStatusList:[
        {
          id:1,
          title:this.$t('label.project.status.1')
        },
        {
          id:2,
          title:this.$t('label.project.status.2')
        },
        {
          id:0,
          title:this.$t('label.project.status.0')
        }
      ]
    };
  },
  computed: {
    filteredCompanyList() {
      const query = (this.companyQuery || "").toLowerCase();
      if (!query) {
        return this.companyList;
      }
      return this.companyList.filter(item => {
        const title = ((item && item.title) || "").toLowerCase();
        return title.indexOf(query) > -1;
      });
    },
    isDark() {
      return this.$store.state.brpaModule.theme === "dark";
    },
    isEN() {
      return (
        localStorage.getItem("locale") &&
        localStorage.getItem("locale") === "en"
      );
    }
  },
  created() {
    this.getConditions();
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === "/pbr/project/detail") {
      sessionStorage.setItem("isBack", 1);
    }
    next();
  },
  activated() {
    if (this.$route.query.keyProject) {
      this.reset(true);
      this.searchForm.weight = this.$route.query.keyProject;
      this.search();
    } else {
      if (this.$route.query.key && this.$route.query.n) {
        this.searchForm.country = [];
        this.searchForm.country.push(
          JSON.stringify({
            id: this.$route.query.key,
            title: this.$route.query.n
          })
        );
        this.isAdvanceSearch = true;
      }

      if (this.$route.params && Object.keys(this.$route.params).length) {
        let {
          currentModuleParams,
          currentModuleTags,
          tabPath
        } = this.$route.params;
        let pdate = currentModuleTags
          .filter(c => c.type === "signDate" || c.type === "date")
          .map(c => {
            let dateArray = [];
            dateArray.push(c.start);
            dateArray.push(c.end);
            return dateArray;
          });
        this.searchForm = {
          country: currentModuleTags
            .filter(c => c.type === "country")
            .map(c =>
              JSON.stringify({
                id: c.id,
                title: c.title
              })
            ),
          industry: currentModuleTags
            .filter(c => c.type === "industry")
            .map(c =>
              JSON.stringify({
                id: c.id,
                title: c.title
              })
            ),
          company: currentModuleTags
            .filter(c => c.type === "company")
            .map(c =>
              JSON.stringify({
                id: c.id,
                title: c.title
              })
            ),
          category: currentModuleTags
            .filter(c => c.type === "category")
            .map(c =>
              JSON.stringify({
                id: c.id,
                title: c.title
              })
            ),
          stage: currentModuleTags
            .filter(c => c.type === "stage")
            .map(c => JSON.stringify({ id: c.id, title: c.title })),
          amount: currentModuleTags
            .filter(c => c.type === "amount")
            .map(c => {
              return JSON.stringify({
                end: c.end,
                id: c.id,
                start: c.start,
                title: c.title
              });
            }),
          pdate: pdate.length > 0 ? pdate[0] : [],
          date: [],
          keywords: "",
          orderby: "",
          orderkey: "",
          name: "",
          searchkeys: "",
          biddingProjectType: "",
          projectStatus: null
        };
        this.searchForm.keywords = currentModuleParams.keywords;
        this.searchForm.searchkeys = currentModuleParams.searchkeys.join(",");
        this.isAdvanceSearch = true;
      }
      let isBack = sessionStorage.getItem("isBack")
        ? sessionStorage.getItem("isBack")
        : 0;
      if (isBack == 1) {
        sessionStorage.removeItem("isBack");
      } else {
        this.search();
      }
    }
  },
  methods: {
    // 海外招标页面标识，header 中 overseasProject=1（0：全球项目，2：海外项目）
    overseasAxiosConfig() {
      return { headers: { overseasProject: 1 } };
    },
    delAllHistory() {
      this.$pbrAxios
        .post(
          "/front/searchHistory/delAllHistory",
          {
            type: "front",
            subtype: "project"
          },
          this.overseasAxiosConfig()
        )
        .then(data => {
          //this.$iMessage.success(this.$t('message.success.delete'))
          this.getHistoryList();
        });
    },
    handleResize() {
      let that = this;
      let fullWidth = document.documentElement.clientWidth;
      if (fullWidth <= 992 && !that.isSmall) {
        that.isSmall = true;
      }
      if (fullWidth > 992 && that.isSmall) {
        that.isSmall = false;
      }

      this.columns = [
      {
          type: "selection",
          width: 40,
          align: "center",
          fixed: "left"
        },
        {
          title: " ",
          width: 40,
          slot: "favorites",
          align: "center",
          fixed: "left"
        },
        {
          title: this.$t("table.project.main.title"),
          slot: "title",
          minWidth: 300,
          className: "table-head-style",
          fixed: `${this.isSmall ? "" : "left"}`
        },
        {
          title: this.$t("table.project.main.country"),
          key: "country",
          width: 120,
          className: "table-head-style",
          // sortable: true
          sortable: "custom"
        },
        {
          title: this.$t("table.project.main.state"),
          slot: "projectStatus",
          key: "projectStatus",
          width: 120,
          align: "center",
          className: "table-head-style",
          sortable: "custom"
        },
        {
          title: this.$t("table.project.main.biddingProjectType"),
          key: "category",
          width: 120,
          className: "table-head-style",
          sortable: "custom"
        },
        {
          title: this.$t("table.project.main.projectDomain"),
          key: "projectDomain",
          width: 140,
          className: "table-head-style",
          sortable: "custom"
        },
        {
          title: this.$t("label.project.detail.projectBidPublishDate"),
          key: "projectBidPublishDate",
          slot: "projectBidPublishDate",
          width: 180,
          className: "table-head-style",
          sortable: "custom"
        },
        {
          title: this.$t("label.project.detail.projectEndDate"),
          key: "projectDeadline",
          slot: "projectDeadline",
          width: 180,
          className: "table-head-style",
          sortable: "custom"
        },
    
      ];
    },

    formatProjectStatus(status) {
      const key = `label.project.status.${status}`;
      const text = this.$t(key);
      return text === key ? this.$t("label.project.status.0") : text;
    },
    formatDateTime(value) {
      if (!value) return "";
      return this.$moment(value).isValid()
        ? this.$moment(value).format("yyyy-MM-DD HH:mm:ss")
        : value;
    },
    projectAmountForTooltip(data) {
      let count = parseFloat(data);
      if (!isNaN(count)) {
        if (this.isEN) {
          return count / 10 + " " + this.$t("label.project.HM");
        }
        return count + " " + this.$t("label.project.HM");
      }
      return "";
    },
    favIconClass(row) {
      if (row.up) {
        if (this.isDark) {
          return { "fav-icon-dark-active": true };
        }
        return { "fav-icon-active": true };
      } else {
        if (this.isDark) {
          return { "fav-icon-dark": true };
        }
        return { "fav-icon": true };
      }
    },
    advanceSearchBtnClick(advance) {
      this.isAdvanceSearch = advance;
    },
    clearSearchCondition(key) {
      if (key === "biddingProjectType") {
        this.searchForm.biddingProjectType = "";
      } else if (key === "projectStatus") {
        this.searchForm.projectStatus = null;
      } else if (key === "weight") {
        this.searchForm.weight = "";
      } else if (key === "pdate") {
        this.searchForm.pdate = [];
      } else {
        this.searchForm[key] = [];
      }
    },
    projectListTableSortChange(options) {
      let { column, key, order } = options;
      // 综合：zh 金额：je  行业：hy  状态：zt   国家：gj   日期：rq   默认是综合国家：gj , 项目状态：xmzt , 项目发布事件：fbsj ,项目截至时间：jzsj 
      let orderkeyEnum = {
        amount: "je",
        industry: "hy",
        signDate: "rq",
        status: "zt",
        country: "gj",
        projectStatus:"xmzj",
        projectBidPublishDate:"fbsj",
        projectDeadline:"jzsj",
        category:'lb',
        projectDomain:'xmly',
      };
      if (order === "normal") {
        this.searchForm.orderby = "";
        this.searchForm.orderkey = "";
      } else {
        this.searchForm.orderby = order;
        this.searchForm.orderkey = orderkeyEnum[key];
      }
      this.search();
    },
    maxTagPlaceholder(num) {
      return "... " + num;
    },
    tableSelectionChange(selection) {
      this.tableSelection = selection;
    },
    openPublishModal() {
      this.$refs.publish.open();
    },
    exportPDF() {
      let that = this;
      if (this.tableSelection.length === 0) {
        this.$confirm(
          that.$t("message.warning.prompt.export"),
          that.$t("message.warning.prompt.title"),
          {
            confirmButtonText: that.$t("buttons.ok"),
            cancelButtonText: that.$t("buttons.cancel"),
            type: "warning"
          }
        )
          .then(() => {
            exportFilePost(
              this.action,
              this.getSearchParams(),
              this.$t("label.export.biddingList"),
              contentType.excel,
              ".xlsx",
              err => {
                if (err) {
                }
              },
              this.overseasAxiosConfig()
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: that.$t("message.warning.prompt.exportFailure")
            });
          });
      } else {
        let selectionIds = this.tableSelection.map(t => t.id);
        exportFile(
          this.action,
          {
            selections: selectionIds.join(","),
            from: this.locale
          },
          this.$t("label.export.biddingList"),
          contentType.excel,
          ".xlsx",
          null,
          this.overseasAxiosConfig()
        );
      }
    },
    /**/
    getConditions() {
      this.$pbrAxios
        .post(
          "/front/project/gconditions",
          { from: this.locale },
          this.overseasAxiosConfig()
        )
        .then(res => {
          if (!res) {
            //this.$iMessage.error({content: '获取检索条件失败', duration: 5})
          } else if (res.code === 200) {
            this.countryList = res.result.regionModels.children;
            this.industryList = res.result.industryModels;
            this.categoryList = res.result.typeModels;
            this.companyList = res.result.enterpriseModels;
            this.stageList = res.result.stageModels;
            this.amountList = res.result.amountModels;
            this.dateList = res.result.dateModels;
            // this.$pbrApis.fetchRegionList({}).then(res => {
            //   if (res.success) {
            //     this.countryList = res.result
            //   }
            // })
          }
        })
        .catch(err => {
          //this.$iMessage.error({content: err.message, duration: 5})
        });
    },
    getSearchParams(byName = false) {
      function filterSearchParams(obj) {
        let arr = [];
        obj.forEach(item => {
          arr.push(JSON.parse(item).id);
        });
        return arr.join();
      }

      if (byName) {
        return {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          name: this.searchForm.name ? this.searchForm.name.trim() : "",
          orderby: this.searchForm.orderby,
          orderkey: this.searchForm.orderkey,
          searchModel: 1
        };
      }

      return {
        from: this.locale,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        country: filterSearchParams(this.searchForm.country),
        industry: filterSearchParams(this.searchForm.industry),
        company: filterSearchParams(this.searchForm.company),
        category: filterSearchParams(this.searchForm.category),
        stage: filterSearchParams(this.searchForm.stage),
        amount: filterSearchParams(this.searchForm.amount),
        pdate: this.searchForm.pdate.join(","),
        date: filterSearchParams(this.searchForm.date),
        keywords: this.searchForm.keywords
          ? this.searchForm.keywords.trim()
          : "",
        orderby: this.searchForm.orderby,
        orderkey: this.searchForm.orderkey,
        weight: this.searchForm.weight,
        biddingProjectType: this.searchForm.biddingProjectType
          ? this.searchForm.biddingProjectType.trim()
          : "",
        projectStatus:
          this.searchForm.projectStatus !== null &&
          this.searchForm.projectStatus !== undefined &&
          this.searchForm.projectStatus !== ""
            ? this.searchForm.projectStatus
            : ""
      };
    },
    getTableData(byName = false) {
      this.isSearchByName = byName;
      this.$iSpin.show();
      let str = new Set(),
        _this = this;

      function eachMyCondition(obj) {
        _this.myCondition[obj].list.forEach(o => {
          str.add(JSON.parse(o).title);
        });
      }

      if (byName) {
        this.searchForm.name ? str.add(this.searchForm.name) : "";
      } else {
        this.myCondition.country ? eachMyCondition("country") : "";
        this.myCondition.industry ? eachMyCondition("industry") : "";
        this.myCondition.category ? eachMyCondition("category") : "";
        this.myCondition.company ? eachMyCondition("company") : "";
        this.myCondition.stage ? eachMyCondition("stage") : "";
        this.myCondition.amount ? eachMyCondition("amount") : "";
        this.myCondition.date ? eachMyCondition("date") : "";
        this.searchForm.keywords ? str.add(this.searchForm.keywords) : "";
        this.myCondition.biddingProjectType
          ? str.add(this.searchForm.biddingProjectType.trim())
          : "";
        this.myCondition.projectStatus
          ? str.add(this.myCondition.projectStatus.text)
          : "";
      }

      let params = this.getSearchParams(byName);
      params.searchkey =
        Array.from(str).join() || this.searchForm.searchkeys || "";

      // this.tableLoading = true
      this.$pbrAxios
        .post("/front/project/search", params, this.overseasAxiosConfig())
        .then(data => {
          // this.tableLoading = false
          if (data.success) {
            this.tableTotal = data.result.rows;
            this.tableData = data.result.models;
            // this.$refs.questionIcon.click()
            // 保存搜索记录
            this.$pbrAxios.post(
              "/front/project/saveProjectSearchHistory",
              params,
              this.overseasAxiosConfig()
            );
          } else {
            this.tableTotal = 0;
            this.tableData = [];
            //this.$iMessage.error({content: data.message})
          }
          this.$iSpin.hide();
        })
        .catch(() => {
          this.$iSpin.hide();
        });
    },
    reset(flag) {
      this.searchForm = {
        country: [],
        industry: [],
        company: [],
        category: [],
        stage: [],
        amount: [],
        date: [],
        pdate: [],
        keywords: "",
        name: "",
        orderby: "",
        orderkey: "",
        weight: "",
        biddingProjectType: "",
        projectStatus: null
      };
      if (!flag) {
        this.search();
      }
    },
    search(byName = false) {
      let key = byName ? "name" : "keywords";
      if (this.searchForm[key] && this.searchForm[key].length > 100) {
        //this.$iMessage.error({content: this.$t('message.error.maximum100'), duration: 5})
        return;
      }
      this.currentPage = 1;
      // this.pageSize = 10
      // 项目列表
      this.getTableData(byName);
      // 统计
      this.getProjectData(byName);
      this.getProjectHotWord(byName);
    },
    associationWords(keyword) {
      if (keyword && keyword.length > 100) {
        //this.$iMessage.error({content: this.$t('message.error.maximum100'), duration: 5})
        return;
      }
      // type（0项目搜索   1项目资讯搜索  2商机资讯搜索   3风险资讯搜索   4风险事件搜索  5分析页搜索）

      this.$pbrAxios
        .get("/front/project/associationWords", {
          params: { keyword: keyword, type: 0 },
          ...this.overseasAxiosConfig()
        })
        .then(res => {
          if (res.success) {
            this.associationWordsList = res.result.models;
          }
        });
    },
    /**/
    addFavorites(row, stat) {
      this.$pbrAxios
        .post(
          "/front/project/pfocus",
          {
            id: row.id,
            focus: stat
          },
          this.overseasAxiosConfig()
        )
        .then(data => {
          this.getTableData();
          //stat ? this.$iMessage.success('收藏成功！') : this.$iMessage.success('取消收藏！')
        });
    },
    jumpProjectDetail(row) {
      this.$router.push({
        name: "pbrProjectDetail",
        params: row,
        query: { key: row.id, tab: "bidding" }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getTableData();
    },
    /*统计*/
    getProjectData(byName = false) {
      this.$pbrAxios
        .post(
          "/front/project/statistic",
          this.getSearchParams(byName),
          this.overseasAxiosConfig()
        )
        .then(data => {
          if (data.code === 200) {
            this.projectData = data.result;
          }
        });
    },
    getProjectHotWord(byName = false) {
      this.$pbrAxios
        .post(
          "/front/project/ghotword",
          this.getSearchParams(byName),
          this.overseasAxiosConfig()
        )
        .then(data => {
          if (data.code === 200) {
            this.hotWordData = data.result;
          }
        });
    },
    hotClick(hotWord) {
      this.searchForm.keywords = hotWord;
      this.search();
    },
    /**/
    onCompanyQueryChange(query) {
      if (!this.isCompanyOpen) return;
      // 选择 option 时组件会把 query 置空，此时 searchForm.company 已有值，忽略这个清空，保持筛选结果
      if (query === "" && this.searchForm.company && this.searchForm.company.length > 0) {
        return;
      }
      // 其他情况（正常输入或用户手动删空关键字）都更新 companyQuery
      this.companyQuery = query;
    },
    onCompanyOpenChange(open) {
      this.isCompanyOpen = open;
      if (!open) {
        this.companyQuery = "";
      }
    },
    /**/
    openHistory() {
      this.historyModal = true;
      this.getHistoryList();
    },
    getHistoryList() {
      this.$pbrAxios
        .post("/front/project/ghconditions", {}, this.overseasAxiosConfig())
        .then(data => {
        this.historyTableData = data.result;
      });
    },
    getHistoryTableData(id) {
      this.currentPage = 1;
      this.pageSize = 10;
      this.tableLoading = true;
      this.$pbrAxios
        .post("/front/project/hsearch", { id: id }, this.overseasAxiosConfig())
        .then(data => {
        this.tableLoading = false;
        this.tableTotal = data.result.rows;
        this.tableData = data.result.models;
      });
    },
    getHistoryProjectData(id) {
      this.$pbrAxios
        .post(
          "/front/project/statistic",
          { searchid: id },
          this.overseasAxiosConfig()
        )
        .then(data => {
          if (data && data.code === 200) {
            this.projectData = data.result;
          }
        });
    },
    getHistoryProjectHotWord(id) {
      this.$pbrAxios
        .post(
          "/front/project/ghotword",
          { searchid: id },
          this.overseasAxiosConfig()
        )
        .then(data => {
          this.hotWordData = data.result;
        });
    },
    dblclickHistory(row) {
      function clearObj(obj) {
        for (let i in obj) {
          if (obj[i] === "" || obj[i] === null || obj[i] === undefined) {
            delete obj[i];
          }
        }
      }

      clearObj(row.conditions);
      let country = [];
      this.countryList.forEach((o, i, arr) => {
        if (o.children) {
          o.children.forEach((c, ic, arrc) => {
            if (
              row.conditions.country &&
              row.conditions.country.indexOf(c.id) > -1
            ) {
              let newc = Object.assign({}, c);
              country.push(JSON.stringify(newc, ["id", "title"]));
            }
          });
        }
        if (
          row.conditions.country &&
          row.conditions.country.indexOf(o.id) > -1
        ) {
          let newO = Object.assign({}, o);
          country.push(JSON.stringify(newO, ["id", "title"]));
        }
      });
      // let country = countryList
      // let country = this.countryList.filter((o, i, arr) => {
      //   if (o.children){
      //     return o.children.filter((c, ic, arrc) => {
      //       return row.conditions.country && row.conditions.country.indexOf(c.id) > -1
      //     })
      //   }
      //   return row.conditions.country && row.conditions.country.indexOf(o.id) > -1
      // }).map((o, i, arr) => JSON.stringify(o))
      let industry = this.industryList
        .filter((o, i, arr) => {
          return (
            row.conditions.industry &&
            row.conditions.industry.indexOf(o.id) > -1
          );
        })
        .map((o, i, arr) => JSON.stringify(o));
      let company = this.companyList
        .filter((o, i, arr) => {
          return (
            row.conditions.company && row.conditions.company.indexOf(o.id) > -1
          );
        })
        .map((o, i, arr) => JSON.stringify(o));
      let category = this.categoryList
        .filter((o, i, arr) => {
          return (
            row.conditions.category &&
            row.conditions.category.indexOf(o.id) > -1
          );
        })
        .map((o, i, arr) => JSON.stringify(o));
      let stage = this.stageList
        .filter((o, i, arr) => {
          return (
            row.conditions.stage && row.conditions.stage.indexOf(o.id) > -1
          );
        })
        .map((o, i, arr) => JSON.stringify(o));
      let amount = this.amountList
        .filter((o, i, arr) => {
          return (
            row.conditions.amount && row.conditions.amount.indexOf(o.id) > -1
          );
        })
        .map((o, i, arr) => JSON.stringify(o));
      let keywords = row.conditions.keywords || "";
      let name = row.conditions.name || "";
      let biddingProjectType = row.conditions.biddingProjectType || "";
      let projectStatus =
        row.conditions.projectStatus !== undefined &&
        row.conditions.projectStatus !== null &&
        row.conditions.projectStatus !== ""
          ? Number(row.conditions.projectStatus)
          : null;
      let pdate = row.conditions.pdate ? row.conditions.pdate.split(",") : [];
      let date = this.dateList
        .filter((o, i, arr) => {
          return row.conditions.date && row.conditions.date.indexOf(o.id) > -1;
        })
        .map((o, i, arr) => JSON.stringify({ id: o.id, title: o.title }));
      if (name && name.length > 0) {
        this.advanceSearchBtnClick(false);
      }
      this.searchForm = {
        country,
        industry,
        company,
        category,
        stage,
        amount,
        keywords,
        name,
        pdate,
        date,
        biddingProjectType,
        projectStatus,
        orderby: "",
        orderkey: "",
        weight: ""
      };
      this.historyModal = false;
      this.isAdvanceSearch = true;
      this.getHistoryTableData(row.id);
      this.getHistoryProjectData(row.id);
      this.getHistoryProjectHotWord(row.id);
      this.$pbrAxios
        .post("/front/region/list", {}, this.overseasAxiosConfig())
        .then(res => {
        if (res.success) {
        }
      });
    },
    toTopHistory(row) {
      this.$pbrAxios
        .post(
          "/front/project/upconditions",
          { id: row.id, up: !row.up },
          this.overseasAxiosConfig()
        )
        .then(data => {
          if (row.up) {
            row.up = false;
            //this.$iMessage.success(this.$t('message.success.unUp'))
          } else {
            row.up = true;
            //this.$iMessage.success(this.$t('message.success.up'))
          }
        });
    },
    delHistory(row) {
      this.$pbrAxios
        .post(
          "/front/project/dhconditions",
          { id: row.id },
          this.overseasAxiosConfig()
        )
        .then(data => {
          //this.$iMessage.success(this.$t('message.success.delete'))
          this.getHistoryList();
        });
    },
    editFavorite(row) {
      let that = this;
      let type = row.focue ? "delete" : "add";
      this.$pbrAxios
        .post(
          `/front/userFav/${type}`,
          { id: row.id, type: 3 },
          this.overseasAxiosConfig()
        )
        .then(res => {
          if (!res) {
            //this.$iMessage.error({content: this.$t('message.error.favorite'), duration: 5})
          } else if (res.code === 200) {
            console.log("收藏", res);
            this.$iMessage.success({
              content:
                type === "add"
                  ? this.$t("message.success.favorite")
                  : this.$t("message.success.unfavored"),
              duration: 5
            });
            this.getTableData(this.isSearchByName);
          }
        })
        .catch(err => {
          this.$iMessage.error({ content: err.message, duration: 5 });
        });
    }
  },
  watch: {
    "searchForm.country"(val) {
      if (val && val.length > 0) {
        this.myCondition.country = {
          tag: this.$t("label.country"),
          list: val
        };
      } else {
        delete this.myCondition.country;
      }
    },
    "searchForm.industry"(val) {
      if (val && val.length > 0) {
        this.myCondition.industry = {
          tag: this.$t("label.industry"),
          list: val
        };
      } else {
        delete this.myCondition.industry;
      }
    },
    "searchForm.company"(val) {
      if (val && val.length > 0) {
        this.myCondition.company = {
          tag: this.$t("label.enterprise"),
          list: val
        };
      } else {
        delete this.myCondition.company;
      }
    },
    "searchForm.category"(val) {
      if (val && val.length > 0) {
        this.myCondition.category = {
          tag: this.$t("label.category"),
          list: val
        };
      } else {
        delete this.myCondition.category;
      }
    },
    "searchForm.stage"(val) {
      if (val && val.length > 0) {
        this.myCondition.stage = {
          tag: this.$t("label.stage"),
          list: val
        };
      } else {
        delete this.myCondition.stage;
      }
    },
    "searchForm.amount"(val) {
      if (val && val.length > 0) {
        this.myCondition.amount = {
          tag: this.$t("label.amount"),
          list: val
        };
      } else {
        delete this.myCondition.amount;
      }
    },
    "searchForm.pdate"(val) {
      if (val && val.length > 0 && val[0]) {
        this.myCondition.pdate = {
          tag: this.$t("label.signDate"),
          list: val
        };
      } else {
        delete this.myCondition.pdate;
      }
    },
    "searchForm.weight"(val) {
      if (val && val.length > 0 && val[0]) {
        this.myCondition.weight = {
          tag: this.$t("label.keyProject"),
          list: val
        };
      } else {
        delete this.myCondition.weight;
      }
    },
    "searchForm.biddingProjectType"(val) {
      const text = val ? val.trim() : "";
      if (text) {
        this.myCondition.biddingProjectType = {
          tag: this.$t("table.project.main.biddingProjectType"),
          text
        };
      } else {
        delete this.myCondition.biddingProjectType;
      }
    },
    "searchForm.projectStatus"(val) {
      if (val !== null && val !== undefined && val !== "") {
        const status = this.projectStatusList.find(s => s.id === val);
        this.myCondition.projectStatus = {
          tag: this.$t("table.project.main.state"),
          text: status ? status.title : String(val)
        };
      } else {
        delete this.myCondition.projectStatus;
      }
    }
  }
};
</script>
<style scoped>
.project-title:hover {
  color: #33a2d7;
}

.project-data-content {
  padding: 20px 10px;
}

.pbr-info-history-table >>> .ivu-table td {
  cursor: pointer;
}

>>> .ivu-table th.table-head-style {
  text-align: center;
}

>>> .ivu-table-tbody span {
  word-break: break-word;
}
</style>
